// extracted by mini-css-extract-plugin
export default {"headerLink":"linkedin-searchs_headerLink__Kf1YK","link":"linkedin-searchs_link__vsKsv"};